import isUndefined from "lodash/isUndefined";
import isNull from "lodash/isNull";

import {
  getEmployees,
  getEmployeeById,
  updateEmployeeStatus,
  changeEmployeeStatus,
  removeEmployee,
} from "../repositories/employeeRepository";
import { EMPLOYEE_STATUSES } from "../utilities/constants";

const employeeService = {
  getEmployees: async ({ currentPage, pageSize, search }) => {
    const pageNumber =
      isUndefined(currentPage) || isNull(currentPage) ? 1 : currentPage;
    const itemsPerPage =
      isUndefined(pageSize) || isNull(pageSize) ? 20 : pageSize;

    const params = {
      "current-page": pageNumber,
      "page-size": itemsPerPage,
    };
    if (search?.trim()) params.search = search.trim();
    return await getEmployees(params);
  },

  getEmployeeById: async (id) => await getEmployeeById(id),

  // Bitta hodim statusini o'zgartiradi. statusReason faqat OTHER uchun
  // yuboriladi, boshqa statuslarda null.
  changeEmployeeStatus: async (id, { status, statusReason }) =>
    await changeEmployeeStatus(id, {
      status,
      statusReason:
        status === EMPLOYEE_STATUSES.OTHER ? statusReason?.trim() : null,
    }),

  updateEmployeeStatus: async (status, body) =>
    await updateEmployeeStatus(status, body),

  // Export va Generate CV uchun. Faqat hali ko'rilmagan (UNVIEWED) hodimlar
  // VIEWED qilinadi — HIRED, CALLED_FOR_INTERVIEW kabi statuslar ustidan
  // yozib yuborilmasin.
  // Avval eski bulk endpoint chaqiriladi: backendda uning status
  // o'zgartirishdan tashqari vazifasi bo'lishi mumkin. U xato bersa (hozir
  // 400 qaytaradi), status baribir o'zgarishi uchun yangi endpoint ishlatiladi.
  markEmployeesAsViewed: async (employees) => {
    const ids = (employees ?? [])
      .filter((employee) => employee?.status === EMPLOYEE_STATUSES.UNVIEWED)
      .map((employee) => employee.id);

    if (ids.length === 0) return [];

    try {
      await updateEmployeeStatus(EMPLOYEE_STATUSES.VIEWED, ids);
    } catch (error) {
      await Promise.all(
        ids.map((id) =>
          changeEmployeeStatus(id, {
            status: EMPLOYEE_STATUSES.VIEWED,
            statusReason: null,
          })
        )
      );
    }

    return ids;
  },

  removeEmployee: async (id) => await removeEmployee(id),
};

export default employeeService;
